import React from "react";

import { Button } from "components";

import ic_more from "assets/images/ic_more.svg";

import "assets/scss/components/buttons/moreButton.scss";



export function MoreButton(props) {
    const { className, iconClassName } = props;

    return (
        <Button
            className={"component-moreButton tableHeaderButtonPadding d-flex align-items-center " +
                (className? className + " ":"")}
            isDecoration_primaryTransparent
        >
            <img
                className={"component-moreButton-icon " + (iconClassName? iconClassName + " ":"")}
                src={ic_more}
                alt={"More Icon"}
            />
        </Button>
    );
}